export default "__VITE_ASSET__DqmuB1qt__"